import React, { useContext } from 'react';
import proptypes from 'prop-types';
import { PLCCPod } from '@thd-olt-component-react/consumer-card-messaging';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { HomepageContext } from './context';

const { string } = proptypes;

export function PrivateLabelCreditCard({ id }) {
  const { urlTmxId, isB2C } = useContext(HomepageContext);
  return (
    <ErrorBoundary name="consumer-card-messaging">
      <div
        id={`plcc-php-${id}`}
        className="sui-h-full"
      >
        <ImpressionProvider
          data={{
            id,
            name: 'PLCCPod',
            component: 'PLCCPod',
            type: 'content',
            position: ''
          }}
        >
          <PLCCPod urlTmxId={urlTmxId} id={id} radiusUpdate={isB2C} />
        </ImpressionProvider>
      </div>
    </ErrorBoundary>
  );
}

PrivateLabelCreditCard.propTypes = {
  id: string,
};

PrivateLabelCreditCard.defaultProps = {
  id: undefined,
};
